import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateProduct } from '../Redux/Action/catelog.action';

const EditProduct = ({ editData, setIsEdit }) => {
    const dispatch = useDispatch();
    const { locationData } = useSelector((state) => state.authReducer)
    const location_id = localStorage.getItem('location_id')
    const [customerData, setCustomerData] = useState({
        product_name: editData?.product_name ?? '',
        sku_id: editData?.sku_id ?? '',
        selling_price: editData?.selling_price ?? '',
        quantity: editData?.quantity ?? '',
        pos_location: location_id,
        variants: editData?.variants ?? []
    })
    useEffect(() => {
        if (editData) {
            setCustomerData({
                ...customerData,
                product_name: editData?.product_name ?? '',
                sku_id: editData?.sku_id ?? '',
                quantity: editData?.quantity ?? '',
                selling_price: editData?.selling_price ?? '',
                ...(location_id && { pos_location: location_id }),
                ...(editData?.variants?.length > 0 && { variants: editData?.variants })
            })
        }
    }, [editData])
    return (
        <div className='p-5 sm:min-w-[460px] flex flex-col gap-4 relative'>
            <div className='flex items-center justify-between'>
                <h4>Edit Product</h4>
            </div>
            <hr className='main-border-color' />
            <form
                onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
                method='post'
                className='w-full'
            >
                <div className='mb-4'>
                    <div>    
                        <label>product name</label>
                    </div>
                    <input
                        type='text'
                        className='w-full'
                        value={customerData?.product_name}
                        placeholder='Product Name'
                        onChange={(e) => setCustomerData({ ...customerData, product_name: e.target.value })}
                    />
                </div>
                <div className='mb-4'>
                    <div>
                        <label>Sku id</label>
                    </div>
                    <input
                        type='text'
                        className='w-full'
                        value={customerData?.sku_id}
                        placeholder='sku id'
                        onChange={(e) => setCustomerData({ ...customerData, sku_id: e.target.value })}
                    />
                </div>
                <div className='mb-4'>
                    <div>
                        <label>Qty</label>
                    </div>
                    <input
                        type='number'
                        className='w-full'
                        value={customerData?.quantity}
                        placeholder='quantity'
                        onChange={(e) => setCustomerData({ ...customerData, quantity: Number(e.target.value) })}
                    />
                </div>
                <div className='mb-4'>
                    <div>
                        <label>Price</label>
                    </div>
                    <input
                        type='number'
                        className='w-full'
                        value={customerData?.selling_price}
                        placeholder='price'
                        onChange={(e) => setCustomerData({ ...customerData, selling_price: e.target.value })}
                    />
                </div>
                {customerData?.variants?.length > 0 &&
                    <>
                        <label className='my-2'>Variant</label>
                        {customerData.variants.map((elem, index) => (
                            <>
                                <div className='mb-2'>
                                    {elem?.group?.map((elem, index) => (
                                        <label className='ml-1' key={index}>{`${elem?.group_name}: ${elem?.group_value}`}</label>
                                    ))
                                    }
                                </div>
                                <div key={index} className='grid grid-cols-2 gap-2 mb-4'>
                                    <div>
                                        <div>
                                            <label>Qty</label>
                                        </div>
                                        <input
                                            type="number"
                                            className="w-full"
                                            // value={elem.quantity || ''}
                                            value={elem.pos_quantity?.find(x => x.pos_location === location_id)?.quantity || ''}
                                            placeholder="quantity"
                                            onChange={(e) => {
                                                const newQuantity = Number(e.target.value);
                                                setCustomerData((prevData) => ({
                                                    ...prevData,
                                                    variants: prevData.variants.map((v, vi) =>
                                                        vi === index // Match the correct variant
                                                            ? {
                                                                ...v,
                                                                pos_quantity: v.pos_quantity.map((p) =>
                                                                    p.pos_location === location_id
                                                                        ? { ...p, quantity: newQuantity }
                                                                        : p
                                                                ),
                                                            }
                                                            : v
                                                    ),
                                                }));
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <div>
                                            <label>Price</label>
                                        </div>
                                        <input
                                            type="number"
                                            className="w-full"
                                            value={elem.price || ''}
                                            placeholder="price"
                                            onChange={(e) =>
                                                setCustomerData((prevData) => ({
                                                    ...prevData,
                                                    variants: prevData.variants.map((variant, i) =>
                                                        i === index
                                                            ? { ...variant, price: e.target.value }
                                                            : variant
                                                    ),
                                                }))
                                            }
                                        />
                                    </div>
                                </div>
                            </>
                        ))}
                    </>
                }
                <button type='button' onClick={() => { dispatch(updateProduct(editData?._id, customerData)); setIsEdit(false); setCustomerData({ product_name: '', sku_id: '', selling_price: '' }) }} className={`btn-primary btn-lg text-[18px]`}>Update</button>
            </form>
        </div>
    )
}

export default EditProduct